import { useQuery, useMutation } from '@tanstack/react-query';

// Services
import { getSelectOptions, getTableFilters, postTableFilters } from './tableFiltersService';

export const TABLE_FILTERS_QUERY_KEY = 'tableFilters';

/**
 * Get manager table filters
 * @param {{path: string, contexte?: string | null}} [params = {}] - The query params
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiManagerTableFilters, Error>} The manager table filters
 */
export const useTableFilters = (params = { path: '' }, options = {}) => {
  const { path, contexte = null } = params;
  return useQuery({
    queryKey: [TABLE_FILTERS_QUERY_KEY, path, contexte],
    queryFn: () => getTableFilters(path, contexte),
    ...options,
  });
};

/**
 * Post manager table filters
 * @param {string} path - The path of the page
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiManagerTableFiltersCreate, Error, ApiManagerTableFiltersCreate, unknown>} [options = {}] - The mutation options
 * @param {string | null} [contexte] - The context (optional)
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiManagerTableFiltersCreate, Error, ApiManagerTableFiltersCreate, unknown>} The manager table filters mutation
 */
export const useTableFiltersMutation = (path, options = {}, contexte = null) => useMutation({
  mutationFn: (data) => postTableFilters(path, data, contexte),
  ...options,
});

/**
 * Get select options
 * @param {string} url - The url to fetch the select options
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiManagerTableSelectOptionsOption[], Error>} The select options
 */
export const useSelectOptions = (url, options = {}) => useQuery({
  queryKey: ['selectOptions', url],
  queryFn: () => getSelectOptions(url),
  staleTime: 5 * 60 * 1000,
  ...options,
});
